<template>
	<input
		type="file"
		hidden
		id="upload-file"
		@change="uploadChange"
		multiple
		accept="application/pdf,image/png, image/jpeg, image/jpg"
	/>
	<div class="fixed inset-y-0 right-0 flex side-over z-50 side-over">
		<div class="h-full w-full flex flex-col bg-white shadow-xl min-h-0">
			<div
				class="flex items-center justify-between flex-shrink-0 result-sideover__header"
			>
				<div class="flex items-center result-sideover__title">
					<img :src="fileIcon" alt="" width="24" height="24" />
					{{ isEdit ? 'Chỉnh sửa' : 'Tạo mới' }}
				</div>
				<button
					type="button"
					class="result-sideover__close"
					@click="$emit('close')"
				>
					<img :src="closeIcon" alt="" width="24" height="24" />
				</button>
			</div>
			<div v-if="step === 1" class="result-scale-step">
				<div class="result-scale-step__body">
					<div class="text-neutral-500 mb-6">
						Chọn một loại sàng lọc hoặc đánh giá dưới đây để bắt đầu
					</div>
					<div
						class="flex gap-2 cursor-pointer"
						@click="select = 'document'"
					>
						<input
							type="radio"
							value="document"
							v-model="select"
							class="mt-1 h-5 w-5 text-yellow-600 border-neutral-400 border-2 focus:ring-yellow-600"
						/>
						<div>
							<div class="font-semibold text-neutral-600">
								Hồ sơ thăm khám
							</div>
							<div class="text-neutral-600 mt-2">
								Cho phép tải thêm tài liệu đính kèm như kết quả
								thăm khám, chẩn đoán, kết quả lượng giá, lâm
								sàng...
							</div>
						</div>
					</div>
					<div
						class="flex gap-2 mt-6 cursor-pointer"
						@click="select = 'screening'"
					>
						<input
							type="radio"
							value="screening"
							v-model="select"
							class="mt-1 h-5 w-5 text-yellow-600 border-neutral-400 border-2 focus:ring-yellow-600"
						/>
						<div>
							<div class="font-semibold text-neutral-600">
								Sàng lọc
							</div>
							<div class="text-neutral-600 mt-2">
								Sử dụng các thang sàng lọc có sẵn như A.S.Q 3,
								M-CHAT-R, C.A.R.S, D.S.M 5 để hỗ trợ sàng lọc và
								xác định mức độ biểu hiện của trẻ.
							</div>
						</div>
					</div>
					<div
						v-if="flagCheck()"
						class="flex gap-2 mt-6 cursor-pointer"
						@click="select = 'development'"
					>
						<input
							type="radio"
							value="development"
							v-model="select"
							class="mt-1 h-5 w-5 text-yellow-600 border-neutral-400 border-2 focus:ring-yellow-600"
						/>
						<div>
							<div class="font-semibold text-neutral-600">
								Đánh giá phát triển
							</div>
							<div class="text-neutral-600 mt-2">
								Sử dụng Biểu mẫu tạo sẵn kết hợp cùng Luca AI để
								đánh giá tuổi phát triển cho trẻ
							</div>
						</div>
					</div>
					<div
						v-if="canCreatePlan"
						class="flex gap-2 mt-6 cursor-pointer"
						@click="select = 'intervention'"
					>
						<input
							type="radio"
							value="intervention"
							v-model="select"
							class="mt-1 h-5 w-5 text-yellow-600 border-neutral-400 border-2 focus:ring-yellow-600"
						/>
						<div>
							<div class="font-semibold text-neutral-600">
								Đánh giá quá trình can thiệp
							</div>
							<div class="text-neutral-600 mt-2">
								Chọn khoảng thời gian bất kỳ và tổng hợp kết quả
								các mục tiêu trẻ đã hoàn thành trong khoảng thời
								gian đó, kết hợp cùng Luca AI để hỗ trợ đánh giá
								tuổi phát triển của trẻ.
							</div>
						</div>
					</div>
				</div>
				<div class="result-scale-step__footer">
					<div class="result-scale-step__actions">
						<button
							type="button"
							class="result-scale-step__next"
							@click="continueStep"
							:disabled="!select"
						>
							Tiếp tục
						</button>
					</div>
				</div>
			</div>
			<div v-if="step === 3" class="result-scale-step">
				<div class="result-scale-step__body">
					<div v-if="loadingScales" class="text-sm text-neutral-400">
						Đang tải...
					</div>
					<ScreeningScaleList
						v-else
						:scales="scales"
						:selected-id="selectedScaleId"
						@select="selectedScaleId = $event"
					/>
				</div>
				<div class="result-scale-step__footer">
					<div class="result-scale-step__actions">
						<button
							type="button"
							class="result-scale-step__back"
							@click="step = 1"
						>
							Quay lại
						</button>
						<button
							type="button"
							class="result-scale-step__next"
							:disabled="!chosenScale"
							@click="continueStep"
						>
							Tiếp tục
						</button>
					</div>
				</div>
			</div>
			<div v-if="step === 2" class="result-scale-step">
				<div class="px-4 sm:px-6">
					<div class="border-b border-neutral-200">
						<nav class="flex space-x-8 tabs" aria-label="Tabs">
							<div
								@click="tab = 0"
								class="order-transparent hover:text-yellow-700 hover:border-yellow-500 whitespace-nowrap pb-6 pt-8 px-1 font-semibold cursor-pointer"
								:class="
									tab === 0
										? 'border-b-2 text-yellow-700 border-yellow-500'
										: 'text-neutral-500'
								"
							>
								Nội dung
							</div>
							<div
								v-if="!resultData.showNote"
								@click="tab = 1"
								class="order-transparent hover:text-yellow-700 hover:border-yellow-500 whitespace-nowrap pb-6 pt-8 px-1 font-semibold cursor-pointer"
								:class="
									tab === 1
										? 'border-b-2 text-yellow-700 border-yellow-500'
										: 'text-neutral-500'
								"
							>
								Tài liệu
							</div>
						</nav>
					</div>
				</div>
				<div class="sideover-content relative flex-1 px-4 sm:px-6">
					<div v-show="tab === 0">
						<div class="text-neutral-600">
							Bạn hãy điền các thông tin dưới đây để tạo kết quả
							sau thăm khám
						</div>
						<div class="w-full mt-5">
							<div class="font-semibold text-neutral-600 mb-2">
								Tên bản đánh giá*
							</div>
							<div class="select-tabs mb-6">
								<div class="input-group flex items-center">
									<input
										v-model="result.name"
										maxlength="100"
										type="text"
										placeholder="vd: đánh giá đầu vào, lượng giá...."
										:class="errorName ? 'text-error' : ''"
									/>
								</div>
								<div
									class="text-sienna-600 text-sm mt-2"
									v-if="errorName"
								>
									Tên {{ errorName }}
								</div>
							</div>
						</div>

						<div class="w-full mt-5">
							<div class="font-semibold text-neutral-600 mb-2">
								Ngày thực hiện*
							</div>
							<div class="select-tabs mb-6">
								<div class="input-group w-full">
									<VueDatepicker
										class="input-date w-full"
										placeholder="Ngày thực hiện đánh giá"
										autoApply
										:enableTimePicker="false"
										uid="filter-by-date"
										format="dd/MM/yyyy"
										v-model="result.assessment_date"
										:class="
											errorCreatedTime ? 'text-error' : ''
										"
										:maxDate="new Date()"
									>
										<template #input-icon>
											<svg
												width="20"
												height="20"
												viewBox="0 0 20 20"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
											>
												<path
													fill-rule="evenodd"
													clip-rule="evenodd"
													d="M5 0.625C5 0.279822 4.72018 0 4.375 0C4.02982 0 3.75 0.279822 3.75 0.625V1.25H2.5C1.11929 1.25 0 2.36929 0 3.75V5H20V3.75C20 2.36929 18.8807 1.25 17.5 1.25H16.25V0.625C16.25 0.279822 15.9702 0 15.625 0C15.2798 0 15 0.279822 15 0.625V1.25H5V0.625ZM20 17.5V6.25H0V17.5C0 18.8807 1.11929 20 2.5 20H17.5C18.8807 20 20 18.8807 20 17.5ZM11.875 8.75C11.5298 8.75 11.25 9.02982 11.25 9.375V10.625C11.25 10.9702 11.5298 11.25 11.875 11.25H13.125C13.4702 11.25 13.75 10.9702 13.75 10.625V9.375C13.75 9.02982 13.4702 8.75 13.125 8.75H11.875ZM15.625 8.75C15.2798 8.75 15 9.02982 15 9.375V10.625C15 10.9702 15.2798 11.25 15.625 11.25H16.875C17.2202 11.25 17.5 10.9702 17.5 10.625V9.375C17.5 9.02982 17.2202 8.75 16.875 8.75H15.625ZM2.5 13.125C2.5 12.7798 2.77982 12.5 3.125 12.5H4.375C4.72018 12.5 5 12.7798 5 13.125V14.375C5 14.7202 4.72018 15 4.375 15H3.125C2.77982 15 2.5 14.7202 2.5 14.375V13.125ZM6.875 12.5C6.52982 12.5 6.25 12.7798 6.25 13.125V14.375C6.25 14.7202 6.52982 15 6.875 15H8.125C8.47018 15 8.75 14.7202 8.75 14.375V13.125C8.75 12.7798 8.47018 12.5 8.125 12.5H6.875Z"
													fill="#94A3B8"
												/>
											</svg>
										</template>
									</VueDatepicker>
								</div>
								<div
									class="text-sienna-600 text-sm mt-2"
									v-if="errorCreatedTime"
								>
									Ngày thực hiện
									<span v-html="errorCreatedTime"></span>
								</div>
							</div>
						</div>
						<div class="w-full mt-5">
							<div class="font-semibold text-neutral-600 mb-2">
								Kết luận
							</div>
							<div
								class="select-tabs mb-6 flex items-center gap-6"
								v-for="(a, index) in assessment_conclusions"
								:key="index"
							>
								<Multiselect
									v-if="optionResult.length > 0"
									v-model="assessment_conclusions[index]"
									:options="
										optionResult.filter(
											(s) =>
												!assessment_conclusions.includes(
													s
												)
										)
									"
									:searchable="true"
									selectLabel=""
									placeholder="Kết luận về tình trạng của h.s"
									selectedLabel=""
									deselectLabel="Ấn đễ bỏ chọn"
								>
									<template #noResult>
										Không tìm thấy kết quả
									</template>
								</Multiselect>
								<DaIcon
									@click="
										assessment_conclusions.length > 1 &&
											index !==
												assessment_conclusions.length &&
											removeConclusions(index)
									"
									name="das--delete"
									class="h-4 w-4"
									:class="
										assessment_conclusions.length > 1 &&
										index !== assessment_conclusions.length
											? 'text-yellow-600 hover:text-yellow-700 active:text-yellow-500 cursor-pointer'
											: 'text-neutral-300'
									"
								/>
							</div>
							<div class="flex justify-end gap-6">
								<div
									@click="addConclusions"
									class="font-semibold text-yellow-700 mb-2 text-sm text-right cursor-pointer"
								>
									Thêm chẩn đoán
								</div>
								<div
									class="h-4 w-4"
									style="min-width: 8px"
								></div>
							</div>
						</div>
						<div class="w-full mt-5">
							<div class="font-semibold text-neutral-600 mb-2">
								Tuổi phát triển
							</div>
							<div class="select-tabs mb-6">
								<div
									class="input-group flex items-center mb-4 relative gap-6"
									v-for="(
										d, index
									) in development_ages.length"
									:key="index"
								>
									<input
										v-model="development_ages[index]"
										type="text"
										placeholder="Tuổi phát triển của h.s ở thời điểm đánh giá"
										style="padding-right: 30px"
									/>
									<DaIcon
										@click="
											development_ages.length > 1 &&
												index !==
													development_ages.length &&
												removeAge(index)
										"
										:class="
											development_ages.length > 1 &&
											index !== development_ages.length
												? 'text-yellow-600 hover:text-yellow-700 active:text-yellow-500 cursor-pointer'
												: 'text-neutral-300'
										"
										name="das--delete"
										class="h-4 w-4"
									/>
								</div>
							</div>
							<div class="flex justify-end gap-6">
								<div
									@click="addAge"
									class="font-semibold text-yellow-700 mb-2 text-sm text-right cursor-pointer"
								>
									Thêm tuổi phát triển
								</div>
								<div
									class="h-4 w-4"
									style="min-width: 8px"
								></div>
							</div>
						</div>
						<div class="w-full mt-5">
							<div class="font-semibold text-neutral-600 mb-2">
								Đơn thuốc
							</div>
							<div class="select-tabs mb-6">
								<div
									class="input-group flex items-center mb-4 relative gap-6"
									v-for="(p, index) in prescription.length"
									:key="index"
								>
									<input
										v-model="prescription[index]"
										type="text"
										placeholder="Đơn thuốc của h.s ở thời điểm đánh giá"
										style="padding-right: 30px"
									/>
									<DaIcon
										@click="
											prescription.length > 1 &&
												index !== prescription.length;
											removePescription(index);
										"
										:class="
											prescription.length > 1 &&
											index !== prescription.length
												? 'text-yellow-600 hover:text-yellow-700 active:text-yellow-500 cursor-pointer'
												: 'text-neutral-300'
										"
										name="das--delete"
										class="h-4 w-4"
									/>
								</div>
							</div>
							<div class="flex justify-end gap-6">
								<div
									@click="addPescription"
									class="font-semibold text-yellow-700 mb-2 text-sm text-right cursor-pointer"
								>
									Thêm đơn thuốc
								</div>
								<div
									class="h-4 w-4"
									style="min-width: 8px"
								></div>
							</div>
						</div>
						<div class="w-full mt-5" v-if="resultData.showNote">
							<div class="font-semibold text-neutral-600 mb-2">
								Nhận xét
							</div>
							<div>
								<textarea
									v-model="result.note"
									placeholder="Nhận xét"
									style="
										height: 100%;
										resize: none;
										min-height: 100px;
									"
								></textarea>
							</div>
						</div>
					</div>
					<div v-show="tab === 1">
						<div v-if="result.files.length">
							<div
								v-for="(file, index) in result.files"
								:key="file.id"
								class="flex items-center justify-between mb-6"
							>
								<div class="text-neutral-600 w-11/12 truncate">
									{{ index + 1 }}. {{ file.name }}
								</div>
								<div
									@click="deleteFile(file.id)"
									class="flex items-center text-blue-700 hover:text-blue-800 font-semibold cursor-pointer text-sm"
								>
									<svg
										class="mr-2"
										width="16"
										height="16"
										viewBox="0 0 16 16"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											fill-rule="evenodd"
											clip-rule="evenodd"
											d="M2.5 1C1.94772 1 1.5 1.44772 1.5 2V3C1.5 3.55228 1.94772 4 2.5 4H3V13C3 14.1046 3.89543 15 5 15H11C12.1046 15 13 14.1046 13 13V4H13.5C14.0523 4 14.5 3.55228 14.5 3V2C14.5 1.44772 14.0523 1 13.5 1H10C10 0.447715 9.55229 0 9 0H7C6.44772 0 6 0.447715 6 1H2.5ZM5.5 5C5.77614 5 6 5.22386 6 5.5V12.5C6 12.7761 5.77614 13 5.5 13C5.22386 13 5 12.7761 5 12.5L5 5.5C5 5.22386 5.22386 5 5.5 5ZM8 5C8.27614 5 8.5 5.22386 8.5 5.5V12.5C8.5 12.7761 8.27614 13 8 13C7.72386 13 7.5 12.7761 7.5 12.5V5.5C7.5 5.22386 7.72386 5 8 5ZM11 5.5C11 5.22386 10.7761 5 10.5 5C10.2239 5 10 5.22386 10 5.5V12.5C10 12.7761 10.2239 13 10.5 13C10.7761 13 11 12.7761 11 12.5V5.5Z"
											fill="currentColor"
										/>
									</svg>
								</div>
							</div>
							<div
								class="flex items-center justify-end"
								v-if="result.files.length < 10"
							>
								<div
									class="mt-4 ml-auto"
									@click="openModelUpload"
								>
									<button
										type="button"
										class="button-p text-center bg-none shadow-none flex items-center justify-center btn--text w-fit"
									>
										<svg
											class="mr-2"
											width="24"
											height="24"
											viewBox="0 0 24 24"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												fill-rule="evenodd"
												clip-rule="evenodd"
												d="M12 0C9.86038 0 7.96764 0.840683 6.60864 2.01273C5.45978 3.00355 4.62719 4.29255 4.41334 5.5875C1.89879 6.14267 0 8.33267 0 10.9773C0 14.049 2.56131 16.5 5.67188 16.5H11.25V8.56066L8.03033 11.7803C7.73744 12.0732 7.26256 12.0732 6.96967 11.7803C6.67678 11.4874 6.67678 11.0126 6.96967 10.7197L11.4697 6.21967C11.7626 5.92678 12.2374 5.92678 12.5303 6.21967L17.0303 10.7197C17.3232 11.0126 17.3232 11.4874 17.0303 11.7803C16.7374 12.0732 16.2626 12.0732 15.9697 11.7803L12.75 8.56066V16.5H19.0312C21.7535 16.5 24 14.3542 24 11.6591C24 9.20484 22.1371 7.20616 19.7485 6.86847C19.3849 2.99916 16.0354 0 12 0Z"
												fill="currentColor"
											/>
											<path
												fill-rule="evenodd"
												clip-rule="evenodd"
												d="M11.25 21.75V16.5H12.75V21.75C12.75 22.1642 12.4142 22.5 12 22.5C11.5858 22.5 11.25 22.1642 11.25 21.75Z"
												fill="currentColor"
											/>
										</svg>
										Tải lên tài liệu đánh giá
									</button>
								</div>
							</div>
						</div>
						<div v-else>
							<div class="text-neutral-500">
								Bạn hãy tải lên các tài liệu về kết quả thăm
								khám của trẻ (nếu có)
							</div>
							<div
								class="text-neutral-500 flex flex-col items-center justify-senter text-center gap-2 rounded-lg mt-6 p-8 cursor-pointer border-2 border-dashed hover:border-yellow-500"
								@click="openModelUpload"
							>
								<svg
									width="48"
									height="48"
									viewBox="0 0 48 48"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										fill-rule="evenodd"
										clip-rule="evenodd"
										d="M24 0C19.7208 0 15.9353 1.68137 13.2173 4.02545C10.9196 6.0071 9.25438 8.5851 8.82668 11.175C3.79759 12.2853 0 16.6653 0 21.9545C0 28.098 5.12261 33 11.3438 33H22.5V17.1213L16.0607 23.5607C15.4749 24.1464 14.5251 24.1464 13.9393 23.5607C13.3536 22.9749 13.3536 22.0251 13.9393 21.4393L22.9393 12.4393C23.5251 11.8536 24.4749 11.8536 25.0607 12.4393L34.0607 21.4393C34.6464 22.0251 34.6464 22.9749 34.0607 23.5607C33.4749 24.1464 32.5251 24.1464 31.9393 23.5607L25.5 17.1213V33H38.0625C43.507 33 48 28.7085 48 23.3182C48 18.4097 44.2743 14.4123 39.4971 13.7369C38.7699 5.99831 32.0707 0 24 0Z"
										fill="#F0BB4F"
									/>
									<path
										fill-rule="evenodd"
										clip-rule="evenodd"
										d="M22.5 43.5V33H25.5V43.5C25.5 44.3284 24.8284 45 24 45C23.1716 45 22.5 44.3284 22.5 43.5Z"
										fill="#F0BB4F"
									/>
								</svg>
								<div class="font-semibold">
									Tải lên tài liệu đánh giá
								</div>
								<div class="text-sm">
									PNG, JPG, PDF, DOCX, XLXS <br />
									Tối đa 10 tài liệu/ học sinh
								</div>
							</div>
						</div>
					</div>
				</div>
				<div v-if="isAlertShow">
					<AlertUpload
						:message="message"
						:type="type"
						@close="closeAlert"
					/>
				</div>
				<div class="px-6 py-4 border-t border-yellow-50">
					<div class="flex justify-end" v-if="tab === 0">
						<div>
							<button
								type="button"
								class="button-p text-center w-32"
								@click="submit"
							>
								Xác nhận
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { Options, Vue } from 'vue-class-component';
import Multiselect from '@suadelabs/vue3-multiselect';
import { $api } from '@/services';
import { PropSync, Watch, Prop } from 'vue-property-decorator';
import AlertUpload from '../../../../../components/elements/alert/AlertUpload';
import heic2any from 'heic2any';
import DaIcon from '@/components/elements/daIcon/DaIcon.vue';
import { FLAG_CHECK } from '@/helper/flagCheck';
import { OPTION_RESULT } from '@/data/optionResult';
import ScreeningScaleList from '@/views/screening/features/ScreeningScaleList.vue';
import filePlusIcon from '@/assets/images/screening/file-earmark-plus.svg';
import closePanelIcon from '@/assets/images/screening/close-x.svg';

@Options({
	name: 'UpdateResultSideOver',
	components: { AlertUpload, Multiselect, DaIcon, ScreeningScaleList },
})
export default class UpdateResultSideOver extends Vue {
	@PropSync('data')
	resultData;

	@PropSync('refresh')
	refresh;

	@Prop({ type: Boolean, default: false })
	isEdit;

	@Prop({ type: Object, default: () => ({}) })
	student;

	tab = 0;
	fileIcon = filePlusIcon;
	closeIcon = closePanelIcon;

	isAlertShow = false;
	message = '';
	type = '';
	step = 1;
	result = {
		id: '',
		name: '',
		assessment_date: null,
		development_age: '',
		files: [],
		note: '',
		showNote: false,
	};
	select = 'document';
	scales = [];
	selectedScaleId = null;
	loadingScales = false;

	assessment_conclusions = [''];
	development_ages = [''];
	prescription = [''];

	optionResult = OPTION_RESULT;

	error = {
		name: [],
		assessment_date: [],
	};

	flagCheck() {
		return FLAG_CHECK('ASSESSMENT_FORM');
	}

	get canCreatePlan() {
		const center = this.$store.state.profile.center_state;
		const state = this.student?.state;
		return center !== 'community' && ['active', 'pending'].includes(state);
	}

	get chosenScale() {
		return this.scales.find(
			(item) =>
				item.id === this.selectedScaleId && this.canSelectScale(item)
		);
	}

	canSelectScale(scale) {
		return scale?.state === 'completed' || scale?.state === 'published';
	}

	async loadScales() {
		this.loadingScales = true;
		try {
			const res = await $api.screening.scales();
			const body = res?.data;
			this.scales = Array.isArray(body) ? body : body?.data || [];
			const first = this.scales.find((item) => this.canSelectScale(item));
			this.selectedScaleId = first ? first.id : null;
		} catch (e) {
			this.scales = [];
			this.selectedScaleId = null;
		} finally {
			this.loadingScales = false;
		}
	}

	@Watch('resultData', { deep: true, immediate: true })
	onResultData(value) {
		if (value) {
			this.assessment_conclusions = value?.assessment_conclusions
				? [...value?.assessment_conclusions]
				: [];
			this.development_ages = value?.development_ages
				? [...value?.development_ages]
				: [];
			this.prescription = value?.prescription
				? [...value?.prescription]
				: [];
			Object.assign(this.result, value);
		}
	}

	@Watch('refresh', { immediate: true })
	onRefresh(value) {
		if (value) {
			this.development_ages = [''];
			this.prescription = [''];
			this.result = {
				id: '',
				name: '',
				assessment_date: null,
				development_age: '',
				assessment_conclusions: [''],
				files: [],
				note: '',
				shownote: false,
			};
			this.resultData = {
				id: '',
				name: '',
				assessment_date: null,
				development_age: '',
				assessment_conclusions: [''],
				files: [],
				note: '',
				shownote: false,
			};
			this.tab = 0;
			this.select = 'document';
			this.selectedScaleId = null;
			this.step = this.isEdit ? 2 : 1;
		}
	}

	@Watch('isEdit', { immediate: true })
	onIsEdit(value) {
		if (value) {
			this.step = 2;
		}
	}

	get errorName() {
		if (this.error.name) {
			return this.error.name.join('<br/>');
		} else {
			return '';
		}
	}

	get errorCreatedTime() {
		if (this.error.assessment_date) {
			return this.error.assessment_date.join('<br/>');
		} else {
			return '';
		}
	}

	get id() {
		return Number(this.$route.params.id);
	}

	get resultId() {
		return Number(this.result.id);
	}

	submit() {
		this.isEdit
			? this.updateAssessmentDocument()
			: this.createAssessmentDocument();
	}

	async fetchResultDetail() {
		try {
			const { data } = await $api.student.assessmentDocumentDetail(
				this.id,
				this.result.id
			);
			this.result = data.data;
		} catch (e) {
			await this.$store.dispatch('setAlertMessage', {
				message: 'Đã có lỗi xảy ra. Vui lòng thử lại',
				type: 'danger',
			});
		}
	}

	async createAssessmentDocument() {
		this.error = {
			name: [],
			assessment_date: [],
		};
		if (!this.result.assessment_date) {
			this.error.assessment_date.push('không được để trống');
		}
		if (!this.result.name) {
			this.error.name.push('không được để trống');
		}

		if (this.error.name.length || this.error.assessment_date.length) {
			return;
		}
		try {
			const res = await $api.student.createAssessmentDocuments(this.id, {
				send: false,
				name: this.result.name,
				assessment_date: this.result.assessment_date,
				development_ages: this.development_ages,
				development_age: this.development_ages,
				prescription: this.prescription,
				assessment_conclusions: this.assessment_conclusions,
				assessment_conclusion: this.assessment_conclusions,
				note: this.result.note,
			});

			if (this.result.files.length > 0) {
				this.result.files.forEach((file) =>
					this.uploadFiles(file, res?.data?.data?.id)
				);
			}
			this.result = res?.data?.data;
			// await this.fetchResultDetail();

			this.$emit('success');
			this.message = 'Tạo hồ sơ thăm khám thành công';
			this.isAlertShow = true;

			setTimeout(() => {
				this.closeAlert();
			}, 3000);
			this.tab = 1;
		} catch (e) {
			this.error = e?.response?.data?.errors_by_field || '';
		}
	}

	async updateAssessmentDocument() {
		if (!this.result.assessment_date) {
			this.error.assessment_date.push('không được để trống');
			return;
		}
		try {
			await $api.student.updateAssessmentDocuments(
				this.id,
				this.result.id,
				{
					send: false,
					name: this.result.name,
					assessment_date: this.result.assessment_date,
					development_ages: this.development_ages,
					development_age: this.development_ages,
					prescription: this.prescription,
					assessment_conclusions: this.assessment_conclusions,
					assessment_conclusion: this.assessment_conclusions,
					note: this.result.note,
				}
			);
			this.$emit('success');
			await this.$store.dispatch('setAlertMessage', {
				message: 'Cập nhật kết quả đánh giá thành công.',
			});
		} catch (e) {
			this.error = e?.response?.data?.errors_by_field || '';
		}
	}

	async deleteFile(file_id) {
		try {
			await $api.student.deleteResultFile(
				this.id,
				this.result.id,
				file_id
			);
			if (!this.isEdit) {
				await this.fetchResultDetail();
			} else {
				this.$emit('success');
			}
			this.message = 'Xoá file kết quả đánh giá thành công';
			this.isAlertShow = true;

			setTimeout(() => {
				this.closeAlert();
			}, 3000);
		} catch (e) {
			this.error = e?.response?.data?.errors_by_field || '';
		}
	}

	openModelUpload() {
		const target = document.getElementById('upload-file');
		target ? target.click() : '';
	}

	isFile(icon) {
		const ext = [
			'.jpg',
			'.jpeg',
			'.png',
			'.doc',
			'.docx',
			'.xlsx',
			'.pdf',
			'.heic',
		];
		return ext.some((el) => icon.endsWith(el));
	}

	async uploadChange(event) {
		let file = event.target.files[0];

		if (!file) {
			return;
		}

		if (!this.isFile(file.name)) {
			this.isAlertShow = true;
			this.message = 'Định dạng tệp không hỗ trợ';
			this.type = 'danger';
			const target = document.getElementById('upload-file');
			target ? (target.value = null) : '';
			setTimeout(() => {
				this.closeAlert();
			}, 3000);
			return;
		}
		if (this.resultId) {
			this.uploadFiles(file, this.resultId);
		}
		this.result.files.push(file);
	}

	async prepareUploadFile(file) {
		if (
			/image\/hei(c|f)/.test(file.type) ||
			file.name.endsWith('.heic') ||
			file.name.endsWith('.heif')
		) {
			const jpgBlob = await heic2any({
				blob: file,
				toType: 'image/jpeg',
				quality: 1,
			});
			const newName = file.name.replace(/\.[^/.]+$/, '.jpg');
			return this.blobToFile(jpgBlob, newName);
		}
		return file;
	}

	async getSignatures(file) {
		const {
			data: { data },
		} = await $api.file.getSignatures({
			mime_types: [file.type],
			prefix: 'notice_attachment',
		});
		if (!data?.length) {
			throw new Error('Không lấy được chữ ký upload');
		}

		const signatureData = data[0];
		const formData = new FormData();
		formData.append(
			'AWSAccessKeyId',
			signatureData['AWSAccessKeyId'] || ''
		);
		formData.append('key', signatureData.key || '');
		formData.append('acl', signatureData.acl || '');
		formData.append('Content-Type', signatureData['Content-Type'] || '');
		formData.append('x-amz-signature', signatureData.signature || '');
		formData.append('Signature', signatureData.signature || '');
		formData.append('Policy', signatureData.policy || '');
		formData.append(
			'success_action_status',
			signatureData.success_action_status || ''
		);
		formData.append('file', file);

		const assetKey = await this.uploadToS3(signatureData.action, formData);
		if (!assetKey) {
			throw new Error('Upload S3 thất bại');
		}

		return {
			asset_key: assetKey,
			name: file.name,
			signature: signatureData.signature,
		};
	}

	async uploadToS3(url, payload) {
		const { data } = await $api.file.uploadToS3(url, payload);
		const keyData = data.toString().match('<Key>(.*)</Key>');
		return keyData && keyData.length ? keyData[1] : '';
	}

	async uploadFiles(file, id) {
		try {
			const fileToUpload = await this.prepareUploadFile(file);
			const payload = await this.getSignatures(fileToUpload);
			const res = await $api.student.uploadResultFile(
				this.id,
				id,
				payload
			);
			if (res) {
				this.isAlertShow = true;
				this.message = 'Tải lên tài liệu thành công';
				this.type = '';
			}
			if (!this.resultId) this.$emit('success');
			const target = document.getElementById('upload-file');
			target ? (target.value = null) : '';
			setTimeout(() => {
				this.closeAlert();
			}, 3000);
		} catch (e) {
			console.log(e);
			this.isAlertShow = true;
			this.message = 'Có lỗi xảy ra, tải lên tài liệu không thành công';
			this.type = 'danger';
			setTimeout(() => {
				this.closeAlert();
			}, 3000);
		}
	}

	blobToFile(theBlob, fileName) {
		return new File([theBlob], fileName, {
			lastModified: new Date().getTime(),
			type: theBlob.type,
		});
	}

	closeAlert() {
		this.isAlertShow = false;
		this.message = '';
		this.type = '';
	}

	removeAge(index) {
		this.development_ages.splice(index, 1);
	}

	addAge() {
		this.development_ages.push('');
	}

	removePescription(index) {
		this.prescription.splice(index, 1);
	}

	addPescription() {
		this.prescription.push('');
	}

	removeConclusions(index) {
		this.assessment_conclusions.splice(index, 1);
	}

	addConclusions() {
		this.assessment_conclusions.push('');
	}

	continueStep() {
		if (this.select === 'development') {
			this.$emit('openCreate');
			return;
		}
		if (this.select === 'intervention') {
			this.$emit('openPlan');
			return;
		}
		if (this.select === 'screening') {
			if (this.step !== 3) {
				this.step = 3;
				this.loadScales();
				return;
			}
			if (!this.chosenScale) return;
			this.$emit('screening', this.chosenScale);
			return;
		}
		this.step = 2;
	}
}
</script>

<style scoped lang="scss">
@import '../../../../../assets/styles/responsive';

.side-over {
	width: 100vw;
	padding-left: 0;

	@include media-breakpoint-up(md) {
		width: 512px;
	}
}

.result-sideover__header {
	background: #eef3f8;
	padding: 24px;
}

.result-sideover__title {
	gap: 8px;
	color: #344256;
	font-size: 20px;
	font-weight: 600;
	line-height: 28px;
}

.result-sideover__close {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 24px;
	height: 24px;
}

.result-scale-step {
	display: flex;
	flex: 1;
	flex-direction: column;
	min-height: 0;
}

.result-scale-step__body {
	flex: 1;
	min-height: 0;
	overflow-y: auto;
	padding: 24px;
}

.result-scale-step__footer {
	flex-shrink: 0;
	border-top: 1px solid #faf5f1;
}

.result-scale-step__actions {
	display: flex;
	align-items: center;
	justify-content: flex-end;
	gap: 16px;
	padding: 16px;
}

.result-scale-step__back,
.result-scale-step__next {
	padding: 12px 20px;
	border-radius: 4px;
	font-size: 14px;
	font-weight: 600;
	line-height: 20px;
}

.result-scale-step__back {
	color: #65758b;
}

.result-scale-step__next {
	color: #344256;
	background: #f0bb4f;
	box-shadow: 0 0 1px rgba(12, 26, 75, 0.24), 0 3px 8px rgba(50, 50, 71, 0.05);

	&:disabled {
		opacity: 0.5;
		cursor: default;
	}
}
.sideover-content {
	min-height: 0;
	overflow-y: auto;
	padding-bottom: 24px;
}
</style>
